import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../services';
import { Utils } from '../../utils';
import { MessageService } from 'primeng/api';

@Component({
    moduleId: module.id,
    selector: 'app-auth-login',
    templateUrl: 'auth.component.html',
    styleUrls: ['auth.component.css']
})

export class AuthComponent implements OnInit {

    model: any = {};
    loading = false;
    returnUrl: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private utils: Utils,
        private messageService: MessageService,
        private authenticationService: AuthenticationService) { }

    ngOnInit() {
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard';
    }

    login(): void {
        this.loading = true;

        this.authenticationService.login(this.model.username, this.model.password)
            .subscribe(
                () => {
                    this.router.navigate([this.returnUrl]);
                },
                error => {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Błąd podczas logowania', detail: this.utils.handleError(error) });
                });
    }
}
